"use client";

import React from "react";
import BusinessSectionBlock from "./BusinessSectionBlock";
import rumah from "../../assets/catering-new.jpeg";

export default function BusinessSectionCatering() {
  return (
    <BusinessSectionBlock
      title="Start exploring Catering"
      description="Our catering service provides high-quality meals for a wide range of events, both formal and informal. Featuring diverse menu options—from local Indonesian dishes to international cuisine is prepared hygienically, delivered punctually, and tailored to the needs of participants. Supported by trusted tenants from both within and outside UIII, our catering service offers a practical and professional solution for meetings, seminars, training sessions, and other campus activities."
      image={rumah}
      href="/f&b/catering"
      reverse={true}
    />
  );
}